import { render } from "./ClassroomStats.vue?vue&type=template&id=6610dce3&scoped=true"
import script from "./ClassroomStats.vue?vue&type=script&lang=js"
export * from "./ClassroomStats.vue?vue&type=script&lang=js"

import "./ClassroomStats.vue?vue&type=style&index=0&id=6610dce3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6610dce3"]])

export default __exports__